module.exports = __webpack_public_path__ + "img/Interview Icon - white.220427d3.svg";